//#region Libraries
//#endregion
//#region Styles
import { Column } from "components/styles";
import { ContainerFooter, FooterTitle } from "../styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import RemoteIcon from "icons/RemoteIcon";
import ZoomIcon from "icons/ZoomIcon";
//#endregion

const RemoteFooter = ({
    zoom, isTimeAppointment
}) => {
    return(
        <Column>
            <FooterTitle>
                <span><RemoteIcon size={15}/></span>
                <h3>Zoom</h3>
            </FooterTitle>
            <ContainerFooter>
                <h5>Conéctate a la cita</h5>
                <a href={zoom || null} target="_blank">
                    <CustomButton 
                        width="100%"
                        text="Unirme a zoom"
                        icon={<ZoomIcon />}
                        variant="primary"
                        disabled={!zoom || !isTimeAppointment}/>
                </a>
                <h5>¿No puedes ingresar?</h5>
                <ul>
                    <li>Te recomendamos comunicarte por teléfono con el/la estudiante</li>
                </ul>
            </ContainerFooter>
        </Column>
    );
}

export default RemoteFooter;